module.exports = __webpack_public_path__ + "static/media/user_info.11765851.png";